import styled from '@emotion/styled';

export const PerformanceChartBase = styled.div`
    background-color: ${(p) => p.theme.color.grayDark3};
    width: 100%;
`;

export const Header = styled.div`
    display: flex;
    flex-wrap: wrap;
    background-color: ${(p) => p.theme.color.gray3};
    & > div + div {
        flex: 1 1 500px;
    }
`;
